import React from 'react';

export const Tasks = ({ width = 140, height = 140 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75.5264 24.8865C75.5264 23.3505 76.798 22.1053 78.3666 22.1053H95.4487C99.5989 22.1053 103.158 25.5208 103.158 29.6543V59.8505C103.158 61.3865 101.886 62.6317 100.318 62.6317C98.7491 62.6317 97.4775 61.3865 97.4775 59.8505V29.6543C97.4775 28.6227 96.4922 27.6677 95.4487 27.6677H78.3666C76.798 27.6677 75.5264 26.4225 75.5264 24.8865Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.37665e-05 29.5545C0.0250684 25.4713 3.463 22.1053 7.46941 22.1053H24.4135C25.9333 22.1053 27.1654 23.3414 27.1654 24.8663C27.1654 26.3912 25.9333 27.6273 24.4135 27.6273H7.46941C6.45841 27.6273 5.50374 28.5753 5.50374 29.5994V132.506C5.50374 133.545 6.4339 134.478 7.46941 134.478H95.6886C96.7241 134.478 97.6542 133.545 97.6542 132.506V85.4001C97.6542 83.8752 98.8863 82.639 100.406 82.639C101.926 82.639 103.158 83.8752 103.158 85.4001V132.506C103.158 136.595 99.7638 140 95.6886 140H7.46941C3.40913 140 0.0247634 136.62 1.32041e-05 132.551L1.37665e-05 29.5545Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M123.326 33.967C124.405 32.8883 126.154 32.8883 127.233 33.967L139.191 45.9235C139.709 46.4415 140 47.1441 140 47.8767C140 48.6093 139.709 49.3119 139.191 49.8299L77.1532 111.862C70.5247 118.49 62.6079 119.758 58.0052 115.163C53.4012 110.567 54.6596 102.649 61.2858 96.002L61.2889 95.9989L123.326 33.967ZM125.28 39.8266L65.1988 99.9022C65.1981 99.9029 65.1974 99.9036 65.1967 99.9043C59.4731 105.647 60.534 109.881 61.9087 111.254C63.2848 112.627 67.5228 113.679 73.2465 107.955L133.331 47.8767L125.28 39.8266Z"
      fill="#2ED3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M113.636 43.7501C114.742 42.6447 116.533 42.6447 117.639 43.7501L137.328 63.5371C137.86 64.0685 138.158 64.7895 138.157 65.541C138.157 66.2926 137.857 67.013 137.325 67.5435L113.512 91.2798C112.404 92.3833 110.612 92.3803 109.509 91.273C108.406 90.1657 108.409 88.3735 109.516 87.27L131.321 65.5352L113.636 47.7531C112.531 46.6477 112.531 44.8555 113.636 43.7501Z"
      fill="#2ED3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.7853 111.388C62.919 112.532 62.9136 114.382 61.7732 115.519L54.7018 122.572C53.5614 123.709 51.7178 123.704 50.5841 122.56C49.4503 121.415 49.4558 119.566 50.5962 118.429L57.6675 111.376C58.808 110.239 60.6516 110.244 61.7853 111.388Z"
      fill="#2ED3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.9754 48.4729C35.123 49.4128 35.339 51.1671 34.458 52.3913L28.3953 60.8147C27.8992 61.504 27.1308 61.9078 26.3162 61.9074C25.5016 61.907 24.7336 61.5024 24.2381 60.8127L18.9614 53.4671C18.0813 52.2421 18.2989 50.488 19.4473 49.5492C20.5957 48.6105 22.24 48.8425 23.12 50.0676L26.3194 54.5213L30.3022 48.9876C31.1833 47.7634 32.8278 47.533 33.9754 48.4729ZM33.9754 67.276C35.123 68.2159 35.339 69.9702 34.458 71.1944L28.3953 79.6179C27.8992 80.3072 27.1308 80.711 26.3162 80.7106C25.5016 80.7102 24.7336 80.3056 24.2381 79.6159L18.9614 72.2703C18.0813 71.0452 18.2989 69.2911 19.4473 68.3524C20.5957 67.4136 22.24 67.6457 23.12 68.8707L26.3194 73.3245L30.3022 67.7908C31.1833 66.5666 32.8278 66.3361 33.9754 67.276ZM33.9754 86.0392C35.123 86.9791 35.339 88.7334 34.458 89.9576L28.3953 98.3811C27.8992 99.0704 27.1308 99.4742 26.3162 99.4738C25.5016 99.4734 24.7336 99.0688 24.2381 98.3791L18.9614 91.0335C18.0813 89.8084 18.2989 88.0543 19.4473 87.1156C20.5957 86.1768 22.24 86.4089 23.12 87.6339L26.3194 92.0877L30.3022 86.554C31.1833 85.3298 32.8278 85.0993 33.9754 86.0392Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.6836 54.3423C38.6836 52.8163 39.9292 51.5792 41.4658 51.5792H78.2699C79.8065 51.5792 81.0521 52.8163 81.0521 54.3423C81.0521 55.8684 79.8065 57.1055 78.2699 57.1055H41.4658C39.9292 57.1055 38.6836 55.8684 38.6836 54.3423Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.6836 72.7632C38.6836 71.2372 39.9432 70.0001 41.497 70.0001H69.0282C70.582 70.0001 71.8416 71.2372 71.8416 72.7632C71.8416 74.2893 70.582 75.5264 69.0282 75.5264H41.497C39.9432 75.5264 38.6836 74.2893 38.6836 72.7632Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.6836 91.1844C38.6836 89.6584 39.9588 88.4213 41.5318 88.4213H56.0985C57.6716 88.4213 58.9468 89.6584 58.9468 91.1844C58.9468 92.7105 57.6716 93.9476 56.0985 93.9476H41.5318C39.9588 93.9476 38.6836 92.7105 38.6836 91.1844Z"
      fill="#297FFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.1988 15.389C34.5868 6.65651 42.2851 0 51.5783 0C60.831 0 68.5627 6.65329 69.9567 15.389H78.2335C79.7901 15.389 81.052 16.6256 81.052 18.1511V32.238C81.052 33.7634 79.7901 35.0001 78.2335 35.0001H24.923C23.3664 35.0001 22.1045 33.7634 22.1045 32.238V18.1511C22.1045 16.6256 23.3664 15.389 24.923 15.389H33.1988ZM51.5783 5.52425C44.4308 5.52425 38.6461 11.163 38.613 18.1639C38.6058 19.6844 37.346 20.9132 35.7945 20.9132H27.7415V29.4758H75.4149V20.9132H67.362C65.8105 20.9132 64.5507 19.6844 64.5435 18.1639C64.5104 11.1676 58.6901 5.52425 51.5783 5.52425Z"
      fill="#2ED3B7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.6567 14.8715C49.214 14.8715 48.0283 16.0441 48.0283 17.4999C48.0283 18.9693 49.1872 20.1283 50.6567 20.1283C52.1262 20.1283 53.2851 18.9693 53.2851 17.4999C53.2851 16.044 52.0994 14.8715 50.6567 14.8715ZM42.3672 17.4999C42.3672 12.8902 46.1148 9.21039 50.6567 9.21039C55.1986 9.21039 58.9462 12.8902 58.9462 17.4999C58.9462 22.0959 55.2527 25.7894 50.6567 25.7894C46.0607 25.7894 42.3672 22.0959 42.3672 17.4999Z"
      fill="#2ED3B7"
    />
  </svg>
);
